import React from 'react';
import Icon from './Icon';

const BuildingIcon = (props) => (
    <Icon {...props}>
        <path
            d="M4 21V4A1 1 0 0 1 5 3H13A1 1 0 0 1 14 4V21M2 21H22M14 9H19A1 1 0 0 1 20 10V21M7.5 7H10.5M7.5 11H10.5M7.5 21V17H10.5V21M16 13H18M16 17H18"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default BuildingIcon;